<template>
  <v-main fullscreen class="background">
    <v-container fill-height fluid>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8 lg8>
          <v-form @submit.prevent="login()" autocomplete="disabled">
            <v-card>
              <v-row class="pa-5">
                <!-- logo y nombre del sistema -->
                <v-col class="text-center" cols="12" sm="6">
                  <v-img src="../assets/img/Logo_UNDEF_IUA.png" aspect-ratio="2" contain></v-img>
                  <h4 class="headline mt-4" >Gestion academica docente estudiantes.</h4>
                  <h5 class="subtitle-"></h5>
                </v-col>

                <!-- parte del formulario -->
                <v-col cols="12" sm="6">
                  <h3
                    class="text-h5 font-weight-light mb-2 light-blue--text text--darken-2"
                  >Iniciar sesión en sistemas</h3>
                  <v-text-field
                    name="login"
                    type="text"
                    v-model="credenciales.usuario"
                    label="Usuario"
                    prepend-inner-icon="mdi-account"
                    autocomplete="disabled"
                  ></v-text-field>

                  <v-text-field
                    name="password"
                    type="password"
                    v-model="credenciales.clave"
                    label="Clave"
                    prepend-inner-icon="mdi-lock"
                    autocomplete="disabled"
                  ></v-text-field>

                  <!-- mensajes de error -->
                  <v-alert v-if="error" dark type="error">{{ error }}</v-alert>

                  <!-- boton -->
                  <v-btn
                    type="submit"
                    color="light-blue lighten-2"
                    dark
                    block
                    :loading="cargando"
                  >{{vista.botonIngresar}}</v-btn>
                </v-col>
              </v-row>
            </v-card>
            <v-row>
              <v-col class="text-center">
                <h5>
                  <a
                    class="text-subtitle-2 font-weight-light text-decoration-none white--text"
                    href="https://gestioniua.blito.ar/login/disponibilidad"
                  >Cargar Disponibilidad</a>
                </h5>
              </v-col>
            </v-row>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>
<script>
export default {
  data() {
    return {
      credenciales: {
        usuario: "",
        clave: "",
      },
      vista: {
        titulo: "Sistema",
        subtitulo: "Ingrese descripcion del sistema aquí",
        botonIngresar: "Ingresar",
      },
      error: "",
      cargando: false,
    };
  },
  methods: {
    login() {
      // limpiar error
      this.error = "";

      // le dice que esta cargando...
      this.cargando = true;

      // realiza el login
      this.$auth
        .login({
          username: this.credenciales.usuario,
          password: this.credenciales.clave,
        })
        .then((res) => {})
        .catch((err) => {
          this.cargando = false;
          if (err) {
            if (err.data) {
              this.error = err.data.message;
            }
          }
        });
    },
  },
};
</script>

<style scoped>
.background {
  height: 100%;
  background: rgb(0, 145, 252);
  background: linear-gradient(
    30deg,
    rgba(0, 145, 252, 1) 0%,
    rgba(179, 230, 255, 1) 100%
  );
}
</style>